import React, { useEffect, useState } from 'react';

import styles from './index.module.scss';

interface ButtonProps {
  children: React.ReactNode;
  full?: boolean;
  column?: boolean;
  text?: string;
}

const CtaWrapper: React.FC<ButtonProps> = ({ children, full, column, text }) => {
  return (
    <div className={styles.ctaWrapper + ' ' + (full ? styles.full : '' + (column ? styles.column : ''))}>
      {text && <p className={styles.Text}>{text}</p>}
      {children}
    </div>
  );
};

export default CtaWrapper; 